import React from 'react';

import { Drawer, Box, Stack } from '@metarouter-private/mr-mui';

import { useDrawerContext } from 'app/shared/contexts/drawer';

import DebuggerDrawerHeader from './DebuggerDrawerHeader';
import DebuggerDrawerTabs from './DebuggerDrawerTabs';

export default function DebuggerDrawer() {
  const { drawer } = useDrawerContext();
  const { isOpen, onClose } = drawer;

  return (
    <Drawer open={isOpen} onClose={onClose} anchor="right" width="60%">
      <Box p={2}>
        <Stack>
          <DebuggerDrawerHeader />
          <DebuggerDrawerTabs />
        </Stack>
      </Box>
    </Drawer>
  );
}
